import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BoxPlotOutlinedSvg from "@ant-design/icons-svg/es/asn/BoxPlotOutlined";
import AntdIcon from "../components/AntdIcon";
var BoxPlotOutlined = function BoxPlotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BoxPlotOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BoxPlotOutlined.displayName = 'BoxPlotOutlined';
}
export default /*#__PURE__*/React.forwardRef(BoxPlotOutlined);